import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import POLIGONI from "@/data/poligoni.json";
import { IMAGES } from "@/data/site";
import Reveal from "@/components/Reveal";
import { Eyebrow } from "@/components/PageHeader";

const PoligoniSection = () => (
  <section data-testid="home-poligoni" className="border-t border-white/10 bg-ink">
    <div className="mx-auto grid max-w-[1600px] grid-cols-1 items-center gap-14 px-6 py-24 md:px-12 md:py-32 lg:grid-cols-2">
      <Reveal>
        <Eyebrow>Servizio specialistico</Eyebrow>
        <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white md:text-6xl">
          Manutenzione poligoni di tiro <span className="text-white/30">in tutta Italia.</span>
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60">{POLIGONI.intro[0]}</p>
        <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {POLIGONI.services.map((s) => (
            <li key={s.id} className="flex items-start gap-3 text-sm text-white/75">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" /> {s.title}
            </li>
          ))}
        </ul>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link to={POLIGONI.path} data-testid="home-poligoni-link" className="inline-flex items-center justify-center gap-3 rounded-md bg-brand px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors hover:bg-brand-hover">
            Scopri il servizio <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to="/shop" data-testid="home-poligoni-shop-link" className="inline-flex items-center justify-center gap-3 rounded-md border border-white/20 px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors hover:border-white/50">
            Materiali e ricambi
          </Link>
        </div>
      </Reveal>
      <Reveal delay={150} className="overflow-hidden rounded-xl border border-white/10">
        <img src={IMAGES.poligono} alt="Manutenzione delle linee di tiro di un poligono indoor" loading="lazy" className="aspect-[4/3] w-full object-cover opacity-85" />
      </Reveal>
    </div>
  </section>
);

export default PoligoniSection;
